// Leaflet 1.9.4 leaves a delayed zoom-transition callback behind when a map
// is removed during an animation. The callback then accesses the already
// deleted _mapPane and raises an uncaught "_leaflet_pos" runtime error.
//
// Keep all view changes synchronous so mounting/unmounting the designer cannot
// race with Leaflet's transition callback.
export const LEAFLET_MAP_OPTIONS = Object.freeze({
  zoomAnimation: false,
});

// Leaflet mutates the setView options by adding derived `zoom` and `pan`
// properties. Return a fresh, extensible object for every call so one view
// change cannot leak its derived options into another.
export const createLeafletSetViewOptions = () => ({
  animate: false,
});
